module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_glabellar.70d4c657.png";